import request from '@/api/client';
import { toFormData } from '@/utils/form';

export function login(payload) {
  return request.post('/admin/login', toFormData(payload));
}

export function modifyPassword(payload) {
  return request.post('/admin/modify-password', toFormData(payload));
}

export function modifyAvatar(file) {
  return request.post('/admin/modify-avatar', toFormData({ avatar: file }));
}

export function uploadImage(file) {
  return request.post('/admin/upload-image', toFormData({ image: file }));
}
